import React, { useEffect  } from "react";
import FeaturedCoursesCarousel from "../components/FeaturedCoursesCarousel";
import HeroCarousel from "../components/HeroCarousel";
import "../components/FeaturedCoursesCarousel.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
  const testimonials = [
    {
      quote: 'I had the privilege of undergoing training at Snow Fountain Civil Engineering Vocational Training Institute (now known as The Civil Lab). The program was highly informative and immensely beneficial for students who have recently completed their diploma or degree.',
      name: 'Abhilash Tiwari',
      role: 'Former Assistant Engineer at CRDF',
      image: '/images/students/Abhilash Tiwari.jfif'
    },
    {
      quote: 'I am deeply grateful for the industrial training I received at Snow Fountain Civil Engineering Vocational Training Institute, Lucknow, UP. This hands-on experience laid the foundation for my career, equipping me with the skills and confidence to excel in the construction industry...',
      name: 'Minhaj Umar Khan',
      role: 'Construction Manager, IMECO Overseas Pvt Ltd',
      image: '/images/students/minhaj.jfif'
    },
    {
      quote: 'I am feeling happy to share my experience at Snow Fountain Civil Engineering Vocational Training Institute. I spent a great time of my career during my training here. That training is still helping me in my working career.',
      name: 'Anurag Singh',
      role: 'Assistant Construction Manager at L&T Construction',
      image: '/images/students/Abhilash Tiwari.jfif'
    }
  ];

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });

    return () => {
      AOS.refresh();
    };
  }, []);
  
  return (
    <div>
      {/* Hero Section with Carousel */}
      <div>
        <HeroCarousel/>
      </div>
      {/* About Us Section */}
      <div className="container aboutUsContainer my-5" data-aos="fade-up" style={{margin:"auto"}}>
        <h2 class="text-center mb-4 heading">The Civil Lab</h2>
        <h4 class="text-center mb-4">a.k.a Snow Fountain Civil Engineering Vocational Training Institute </h4>
          <div className="row align-items-center">
            {/* Left Column: Content (60% width) */}
            <div className="col-md-6 pe-4 segoe">
            
                <p>
                  <strong>The Civil Lab</strong>, formerly known as 
                  SFCEVTI (Snow Fountain Civil Engineering Vocational Training Institute), 
                  is a proud subsidiary of <strong>Snow Fountain Consultants</strong>, backed by an &nbsp;
                  <strong>NABL-accredited laboratory</strong>.
                </p>
                <p>
                  Our mission is to make today’s civil engineering students  &nbsp;
                  <strong>industry-ready</strong> by bridging the gap between theory and practice. 
                  We specialize in providing <strong>hands-on training</strong> with modern equipment and 
                  industry-focused courses such as:
                </p>
                <ul>
                  <li>Advanced Surveying Techniques</li>
                  <li>Material Testing & Quality Control</li>
                  <li>AutoCAD Design and Drafting</li>
                  <li>Estimation & Costing</li>
                  <li>Geotagging and Non-Destructive Testing (NDT)</li>
                </ul>
                <p>
                  With over <strong>25 years of expertise</strong>, we empower students to gain practical knowledge, 
                  real-world skills, and the confidence to excel in their civil engineering careers.
                </p>
                <p>
                  <strong>Take your next step</strong> toward a rewarding career with The Civil Lab.
                </p>
            </div>

            {/* Right Column: Image (40% width) */}
            <div className="col-md-6 text-center">
            <div className="zoom-container">
            <img
              src="/images/pics/about-us.png" /* Replace with your actual image path */
              alt="About us"
              className="img-fluid zoom-image rounded shadow-sm"
            />
          </div>
        </div>
      </div>
  
    </div>
    <div className="container industryTrainingContainer my-5 segoe" data-aos="fade-left" style={{margin:"auto"}}>
  <h2 className="text-center mb-4 heading">Industry-Focused Training</h2><br/>
  <div className="row align-items-center">
  <div className="col-md-5 text-center">
  <div className="zoom-container">
    <img
      src="/images/pics/industry-focus.JPG" /* Replace with your actual image path */
      alt="Industry-Focused Civil Training"
      className="img-fluid zoom-image rounded shadow-sm"
    />
  </div>
    </div>
    <div className="col-md-7 pe-4">
      <p>
        In today’s competitive job market, <strong>practical, industry-aligned skills</strong> are the key to employability. Employers in the civil engineering sector are looking for candidates who can seamlessly transition from classrooms to construction sites, equipped with hands-on expertise and technical knowledge.
      </p>
      <p>
        At <strong>The Civil Lab</strong>, we offer <strong>industry-focused training programs</strong> that go beyond textbooks. Our curriculum is designed in collaboration with industry professionals to ensure students are trained on the tools, techniques, and technologies currently in demand.
      </p>
      <p>We focus on:</p>
      <ul>
        <li><strong>Practical Workshops</strong> simulating real-world scenarios</li>
        <li><strong>Modern Equipment Training</strong> for field and lab work</li>
        <li><strong>Live Project Exposure</strong> to enhance problem-solving skills</li>
        <li><strong>Industry-Ready Curriculum</strong> aligned with hiring trends</li>
      </ul>
      <p>
        Our structured approach prepares students to excel in professional roles immediately after completing their training. By combining technical mastery with hands-on experience, we help students bridge the gap between education and employment.
      </p>
      <p>
        Join us to gain the skills, confidence, and industry exposure needed to build a successful career in civil engineering.
      </p>
    </div>
  </div>
    </div>

    {/* Featured Courses Section */}
    <FeaturedCoursesCarousel data-aos="fade-right"/>
    <div className="container py-5 segoe" data-aos="fade-right" style={{margin:"auto"}}>
      <h2 className="text-center mb-4 heading">What Our Students Say</h2> <br/>
      <div className="row">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div className="card shoutout-card h-100 text-center position-relative">
              {/* Top Section: Comment */}
              <div className="testimonial-comment">
                <p className="card-text">"{testimonial.quote}"</p>
              </div>

              {/* Circular Profile Image */}
              <div className="profile-circle">
                <img
                  src={testimonial.image} /* Replace with actual image path */
                  alt="Student"
                  className="rounded-circle"
                />
              </div>

              {/* Bottom Section: Details */}
              <div className="testimonial-details">
                <h5 className="card-title mt-3">{testimonial.name}</h5>
                <small className="text-muted">{testimonial.role}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  );
};

export default Home;
